module.exports = __webpack_public_path__ + "img/products10.9e71e1e9.jpg";